import ellipse from '../../assets/user-1.svg';
import ellipse1 from '../../assets/user-2.svg';
import ellipse2 from '../../assets/user-3.svg';

const Data = [
	{
		id: 1,
		image: ellipse,
		user: 'MaeAde',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I get the following error: test is no defined, whenever I run the codebelow:import WindMouse from ../src/index;test...',
		likes: '30',
		comments: '17',
		date: '5 Days Ago',
		tag: 'java',
	},
	{
		id: 2,
		image: ellipse1,
		user: 'Hauwa ',
		title: 'Html editor with preview[closed]',
		tweet:
			'Any idea or sample project about data structure, binding of a html editor like wix? Having boxes, by click shows context menu, by changing data mo...',
		likes: '20',
		comments: '3',
		date: '2 months Ago',
		tag: 'java',
	},
	{
		id: 3,
		image: ellipse2,
		user: 'Einstein',
		title: 'Overriding Html from a third party components',
		tweet:
			'Aye Im Dave. does any one know how to override the HTML text of third-party software, I use an appointment-scheduling...',
		likes: '10',
		comments: '20',
		date: '5 days Ago',
		tag: 'python',
	},
	{
		id: 4,
		image: ellipse2,
		user: 'Reallady',
		title: 'Firebase cloud functions return api token',
		tweet:
			'I have an axios instance that I use to fetch data: const getQualtrics = axios.create({ baseURL: https://xx1.qualtrics.com/API/v3/, headers:...,',
		likes: '30',
		comments: '17',
		date: '9 months Ago',
		tag: 'android',
	},
	{
		id: 5,
		image: ellipse2,
		user: 'Devlord',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getti...click shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '6 months Ago',
		tag: 'php',
	},
	{
		id: 6,
		image: ellipse2,
		user: 'useranon',
		title: 'Test is not defined[duplicate]',
		tweet:
			'I get the following error: test is not defined, whenever I run the code below: import WindMouse from "../src/index"; test...',
		likes: '10',
		comments: '15',
		date: '5 years Ago',
		tag: 'c++',
	},
	{
		id: 7,
		image: ellipse2,
		user: 'David ',
		title: 'Dependency interjector error when i deploy it',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'ajax',
	},
	{
		id: 8,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'mysql',
	},
	{
		id: 9,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'node.js',
	},
	{
		id: 10,
		image: ellipse2,
		user: 'dipo ',
		title: 'Compress texts into letters and numbers',
		tweet:
			'I want to write a tinyurl clone, and take text like: https://myfunwebsite.com/coolthing and shorten that string to something like..',
		likes: '10',
		comments: '17',
		date: '6 months ago',
		tag: 'c#',
	},
	{
		id: 11,
		image: ellipse2,
		user: 'James',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo',
		likes: '30',
		comments: '17',
		date: '1 year Ago',
		tag: 'react.js',
	},
	{
		id: 12,
		image: ellipse2,
		user: 'giftedhands',
		title: 'CSC calc mixed use of height and width',
		tweet:
			"I have a div element (with a background image) that I want to occupy the smaller of 40% of the parent element's width... ",
		likes: '20',
		comments: '10',
		date: '1 month Ago',
		tag: 'swift',
	},

	{
		id: 13,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'linux',
	},
	{
		id: 14,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'r',
	},
	{
		id: 15,
		image: ellipse,
		user: 'MaeAde',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I get the following error: test is no defined, whenever I run the codebelow:import WindMouse from ../src/index;test...',
		likes: '30',
		comments: '17',
		date: '5 Days Ago',
		tag: 'java',
	},
	{
		id: 16,
		image: ellipse1,
		user: 'Hauwa ',
		title: 'Html editor with preview[closed]',
		tweet:
			'Any idea or sample project about data structure, binding of a html editor like wix? Having boxes, by click shows context menu, by changing data mo...',
		likes: '20',
		comments: '3',
		date: '2 months Ago',
		tag: 'java',
	},
	{
		id: 17,
		image: ellipse2,
		user: 'Einstein',
		title: 'Overriding Html from a third party components',
		tweet:
			'Aye Im Dave. does any one know how to override the HTML text of third-party software, I use an appointment-scheduling...',
		likes: '10',
		comments: '20',
		date: '5 days Ago',
		tag: 'python',
	},
	{
		id: 18,
		image: ellipse2,
		user: 'Reallady',
		title: 'Firebase cloud functions return api token',
		tweet:
			'I have an axios instance that I use to fetch data: const getQualtrics = axios.create({ baseURL: https://xx1.qualtrics.com/API/v3/, headers:...,',
		likes: '30',
		comments: '17',
		date: '9 months Ago',
		tag: 'android',
	},
	{
		id: 19,
		image: ellipse2,
		user: 'Devlord',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getti...click shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '6 months Ago',
		tag: 'php',
	},
	{
		id: 20,
		image: ellipse2,
		user: 'useranon',
		title: 'Test is not defined[duplicate]',
		tweet:
			'I get the following error: test is not defined, whenever I run the code below: import WindMouse from "../src/index"; test...',
		likes: '10',
		comments: '15',
		date: '5 years Ago',
		tag: 'c++',
	},
	{
		id: 21,
		image: ellipse2,
		user: 'David ',
		title: 'Dependency interjector error when i deploy it',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'ajax',
	},
	{
		id: 22,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'mysql',
	},
	{
		id: 23,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'node.js',
	},
	{
		id: 24,
		image: ellipse2,
		user: 'dipo ',
		title: 'Compress texts into letters and numbers',
		tweet:
			'I want to write a tinyurl clone, and take text like: https://myfunwebsite.com/coolthing and shorten that string to something like..',
		likes: '10',
		comments: '17',
		date: '6 months ago',
		tag: 'c#',
	},
	{
		id: 25,
		image: ellipse2,
		user: 'James',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo',
		likes: '30',
		comments: '17',
		date: '1 year Ago',
		tag: 'react.js',
	},
	{
		id: 26,
		image: ellipse2,
		user: 'giftedhands',
		title: 'CSC calc mixed use of height and width',
		tweet:
			"I have a div element (with a background image) that I want to occupy the smaller of 40% of the parent element's width... ",
		likes: '20',
		comments: '10',
		date: '1 month Ago',
		tag: 'swift',
	},

	{
		id: 27,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'linux',
	},
	{
		id: 28,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'r',
	},
	{
		id: 29,
		image: ellipse,
		user: 'MaeAde',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I get the following error: test is no defined, whenever I run the codebelow:import WindMouse from ../src/index;test...',
		likes: '30',
		comments: '17',
		date: '5 Days Ago',
		tag: 'java',
	},
	{
		id: 30,
		image: ellipse1,
		user: 'Hauwa ',
		title: 'Html editor with preview[closed]',
		tweet:
			'Any idea or sample project about data structure, binding of a html editor like wix? Having boxes, by click shows context menu, by changing data mo...',
		likes: '20',
		comments: '3',
		date: '2 months Ago',
		tag: 'java',
	},
	{
		id: 31,
		image: ellipse2,
		user: 'Einstein',
		title: 'Overriding Html from a third party components',
		tweet:
			'Aye Im Dave. does any one know how to override the HTML text of third-party software, I use an appointment-scheduling...',
		likes: '10',
		comments: '20',
		date: '5 days Ago',
		tag: 'python',
	},
	{
		id: 32,
		image: ellipse2,
		user: 'Reallady',
		title: 'Firebase cloud functions return api token',
		tweet:
			'I have an axios instance that I use to fetch data: const getQualtrics = axios.create({ baseURL: https://xx1.qualtrics.com/API/v3/, headers:...,',
		likes: '30',
		comments: '17',
		date: '9 months Ago',
		tag: 'android',
	},
	{
		id: 33,
		image: ellipse2,
		user: 'Devlord',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getti...click shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '6 months Ago',
		tag: 'php',
	},
	{
		id: 34,
		image: ellipse2,
		user: 'useranon',
		title: 'Test is not defined[duplicate]',
		tweet:
			'I get the following error: test is not defined, whenever I run the code below: import WindMouse from "../src/index"; test...',
		likes: '10',
		comments: '15',
		date: '5 years Ago',
		tag: 'c++',
	},
	{
		id: 35,
		image: ellipse2,
		user: 'David ',
		title: 'Dependency interjector error when i deploy it',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'ajax',
	},
	{
		id: 36,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'mysql',
	},
	{
		id: 37,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'node.js',
	},
	{
		id: 38,
		image: ellipse2,
		user: 'dipo ',
		title: 'Compress texts into letters and numbers',
		tweet:
			'I want to write a tinyurl clone, and take text like: https://myfunwebsite.com/coolthing and shorten that string to something like..',
		likes: '10',
		comments: '17',
		date: '6 months ago',
		tag: 'c#',
	},
	{
		id: 39,
		image: ellipse2,
		user: 'James',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo',
		likes: '30',
		comments: '17',
		date: '1 year Ago',
		tag: 'react.js',
	},
	{
		id: 40,
		image: ellipse2,
		user: 'giftedhands',
		title: 'CSC calc mixed use of height and width',
		tweet:
			"I have a div element (with a background image) that I want to occupy the smaller of 40% of the parent element's width... ",
		likes: '20',
		comments: '10',
		date: '1 month Ago',
		tag: 'swift',
	},

	{
		id: 41,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'linux',
	},
	{
		id: 42,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'r',
	},
	{
		id: 43,
		image: ellipse,
		user: 'MaeAde',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I get the following error: test is no defined, whenever I run the codebelow:import WindMouse from ../src/index;test...',
		likes: '30',
		comments: '17',
		date: '5 Days Ago',
		tag: 'java',
	},
	{
		id: 44,
		image: ellipse1,
		user: 'Hauwa ',
		title: 'Html editor with preview[closed]',
		tweet:
			'Any idea or sample project about data structure, binding of a html editor like wix? Having boxes, by click shows context menu, by changing data mo...',
		likes: '20',
		comments: '3',
		date: '2 months Ago',
		tag: 'java',
	},
	{
		id: 45,
		image: ellipse2,
		user: 'Einstein',
		title: 'Overriding Html from a third party components',
		tweet:
			'Aye Im Dave. does any one know how to override the HTML text of third-party software, I use an appointment-scheduling...',
		likes: '10',
		comments: '20',
		date: '5 days Ago',
		tag: 'python',
	},
	{
		id: 46,
		image: ellipse2,
		user: 'Reallady',
		title: 'Firebase cloud functions return api token',
		tweet:
			'I have an axios instance that I use to fetch data: const getQualtrics = axios.create({ baseURL: https://xx1.qualtrics.com/API/v3/, headers:...,',
		likes: '30',
		comments: '17',
		date: '9 months Ago',
		tag: 'android',
	},
	{
		id: 47,
		image: ellipse2,
		user: 'Devlord',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getti...click shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '6 months Ago',
		tag: 'php',
	},
	{
		id: 48,
		image: ellipse2,
		user: 'useranon',
		title: 'Test is not defined[duplicate]',
		tweet:
			'I get the following error: test is not defined, whenever I run the code below: import WindMouse from "../src/index"; test...',
		likes: '10',
		comments: '15',
		date: '5 years Ago',
		tag: 'c++',
	},
	{
		id: 49,
		image: ellipse2,
		user: 'David ',
		title: 'Dependency interjector error when i deploy it',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'ajax',
	},
	{
		id: 50,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'mysql',
	},
	{
		id: 51,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'node.js',
	},
	{
		id: 52,
		image: ellipse2,
		user: 'dipo ',
		title: 'Compress texts into letters and numbers',
		tweet:
			'I want to write a tinyurl clone, and take text like: https://myfunwebsite.com/coolthing and shorten that string to something like..',
		likes: '10',
		comments: '17',
		date: '6 months ago',
		tag: 'c#',
	},
	{
		id: 53,
		image: ellipse2,
		user: 'James',
		title: 'Storing RegEX inside of JSON[Duplicate]',
		tweet:
			'I am trying to create a way to validate specific data types. But I keep getticlick shows context menu, by changing data mo',
		likes: '30',
		comments: '17',
		date: '1 year Ago',
		tag: 'react.js',
	},
	{
		id: 54,
		image: ellipse2,
		user: 'giftedhands',
		title: 'CSC calc mixed use of height and width',
		tweet:
			"I have a div element (with a background image) that I want to occupy the smaller of 40% of the parent element's width... ",
		likes: '20',
		comments: '10',
		date: '1 month Ago',
		tag: 'swift',
	},

	{
		id: 55,
		image: ellipse2,
		user: 'lord repo ',
		title: 'How to use jet-dom as a stand alone in a webpage',
		tweet:
			'I want to use/run jest-dom matchers separately/standalone (not in a test, but in a webpage) like this: import matchers from...',
		likes: '30',
		comments: '17',
		date: '5 years Ago',
		tag: 'linux',
	},
	{
		id: 56,
		image: ellipse2,
		user: 'Noble',
		title: 'Set method when instance iscreated',
		tweet:
			'Is there any way to execute the set method when an instance is created?. I have this piece of code: class CoffeeMachine { _power...',
		likes: '30',
		comments: '17',
		date: '11 months ago',
		tag: 'r',
	},
];

export default Data;
